import React from 'react';
import { Route, Switch } from 'react-router-dom';

import AuthRoute from 'utils/auth/authRoute';
import { UsersRouter, UsersRouterV1, WebhooksRouter, FinanceEntitiesRouter, EmailRouter } from 'components/routing';

import { OrganizationList, EventList } from 'pages';

export const OrganizationRouter = ({ match }) => {
    const { path } = match;
    return (
        <Switch>
            <Route exact path={path} render={() => <OrganizationList />} />
            <Route
                exact
                path={`${path}/O:organizationId/events`}
                render={basenameProps => {
                    const { organizationId } = basenameProps.match.params;
                    return <EventList organizationId={organizationId} />;
                }}
            />
            ]
            <AuthRoute
                allow={['EmailCapacity.ADMIN']}
                path={`${path}/O:organizationId/emails`}
                render={basenameProps => {
                    const { organizationId } = basenameProps.match.params;
                    return <EmailRouter match={basenameProps.match} organizationId={organizationId} />;
                }}
            />
            <AuthRoute
                allow={['RoleCapacity.ADMIN', 'RoleCapacity.OWNER']}
                path={`${path}/O:organizationId/users`}
                render={basenameProps => {
                    const { organizationId } = basenameProps.match.params;
                    return <UsersRouter match={basenameProps.match} organizationId={organizationId} />;
                }}
            />
            <AuthRoute
                allow={['PookCapacity.API_ACCESS', 'PookCapacity.API_ACCESS_ADMIN']}
                path={`${path}/O:organizationId/applications/legacy`}
                render={basenameProps => {
                    const { organizationId } = basenameProps.match.params;
                    return <UsersRouter match={basenameProps.match} organizationId={organizationId} />;
                }}
            />
            <AuthRoute
                allow={['PookCapacity.API_ACCESS', 'PookCapacity.API_ACCESS_ADMIN']}
                path={`${path}/O:organizationId/applications`}
                render={basenameProps => {
                    const { organizationId } = basenameProps.match.params;
                    return <UsersRouterV1 useCase={'applications'} match={basenameProps.match} organizationId={organizationId} />;
                }}
            />
            <AuthRoute
                allow={['PookCapacity.WEBHOOKS', 'PookCapacity.WEBHOOKS_ADMIN', 'PookCapacity.FORMATTERS', 'PookCapacity.FORMATTERS_ADMIN']}
                path={`${path}/O:organizationId/tools`}
                render={basenameProps => {
                    const { organizationId } = basenameProps.match.params;
                    return <WebhooksRouter match={basenameProps.match} organizationId={organizationId} />;
                }}
            />
            <AuthRoute
                allow={['RoleCapacity.ADMIN', 'RoleCapacity.OWNER']}
                path={`${path}/O:organizationId/finance`}
                render={basenameProps => {
                    const { organizationId } = basenameProps.match.params;
                    return <FinanceEntitiesRouter organizationId={organizationId} />;
                }}
            />
        </Switch>
    );
};
